import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
//import { ToastrService } from 'ngx-toastr';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { ClientModel } from 'src/app/shared/models/client.model';
import { IssueDetailModel, IssueModel } from 'src/app/shared/models/issue.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { IssueService } from 'src/app/shared/services/issue.service';
import { IssueDetailComponent } from '../issue-detail-container/issue-detail/issue-detail.component';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-issue-list',
  templateUrl: './issue-list.component.html',
  styleUrls: ['./issue-list.component.css']
})
export class IssueListComponent implements OnInit {

  @Input() call : CallModel;
  @Input() users : UserModel [];
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();


  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['status', 'ticketNo', 'track', 'actions'];
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;

  constructor(private service : IssueService,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private router : Router,
    private dialog : MatDialog ) {

      console.log("IssueListComponent ");

    }

  ngOnInit() {
    this.refreshList();
  }



  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this issue?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "Issue Delete");
        this.gnotify.showSnackBar('Issue Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
      }
    );
  }

  refreshList()
  {
    if(this.call && this.call.client)
    {
       this.service.findByCustomer(this.call.client.clientId).subscribe(
        res => {
          let array = res as IssueDetailModel[];
          this.thisData = new MatTableDataSource(array);
          this.thisData.sort = this.sort;
          this.thisData.paginator = this.paginator;

          console.log("refreshList : " + this.thisData.data.length);
          this.applyFilter()
        },
        err =>{
          console.log(err);
        }
      );

    }
    else
    {
      this.service.getDetailList().subscribe(
        res => {
          let array = res as IssueDetailModel[];
          this.thisData = new MatTableDataSource(array);
          this.thisData.sort = this.sort;
          this.thisData.paginator = this.paginator;

          console.log("refreshList : " + this.thisData.data.length);
          this.applyFilter()
        },
        err =>{
          console.log(err);
        }
      );
    }

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {

    if(this.searchKey == null) return;
    console.log("applyFilter");
    this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onCreate()
  {
    //this.router.navigateByUrl('/issue-detail');
    this.onSelected.emit();
  }

  onEdit(row){
    //this.router.navigateByUrl('/issue-detail?id=' + row.issueId);
    this.onSelected.emit(row);
  }


}
